var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.87549 18.5885L18.1242 12L7.87549 5.41156V18.5885Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6647 7.81564L21.0486 6.4715L19.7045 5.85544L21.0476 5.2456L21.6647 3.89524L22.2818 5.2456L23.6249 5.85544L22.2807 6.4715L21.6647 7.81564ZM17.2361 4.82452L17.9349 3.28721L19.4722 2.58844L17.9349 1.88966L17.2361 0.352356L16.5373 1.88966L15 2.58844L16.5373 3.28721L17.2361 4.82452Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4 21.8L5.15 20.15L6.8 19.4L5.15 18.65L4.4 17L3.65 18.65L2 19.4L3.65 20.15L4.4 21.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnimate);
export default __webpack_public_path__ + "static/media/icon-animate.710908ffa90eae4a9f3b1557a88c32c7.svg";
export { ForwardRef as ReactComponent };